<template>
<div>
  <div id="container" class="box">
    <div layout="row top-left">
      <slot></slot>
      <!--<div v-html="text"></div>-->
      <!--<close-button @click.native="close" self="right"/>-->
    </div>
  </div>
</div>
</template>

<script>
  // import CloseButton from "./CloseButton";
  export default {
    name: "panel",
    // components: {CloseButton},
    methods: {
      close() {
        this.$emit('onClose', this);
      }
    }
    // props:['text']

  }
</script>

<style scoped>
  #container {
    background-color: dimgray;
    border-radius: 0.8rem;
    color: white;
    padding: 3rem;
    margin: 2px;
    font-size: 1.1rem;
    line-height: 1.6rem;
  }

</style>
